
import { getParentsUntil, getAbsoluteHeight } from './utilities.js';

/*
 * Slinky
 * Rather sweetmenus
 * @author Ali Zahid <ali.zahid@live.com>, made pure JS (mostly) by Brandon Borders
 * @license MIT
 */

export class Slinky {
    // default options
    get options() {
        return {
        resize: true,
        speed: 300,
        theme: 'slinky-theme-default',
        title: false
        }
    }

    constructor(element, options = {}) {
        // save settings
        this.settings = {
        ...this.options,
        ...options
        }

        // let's go!
        this._init(element)
    }

    // setup the DOM just for us
    _init(element) {
        // the two elements of water and moisture
        this.menu = element;
        this.base = this.menu.children[0];

        const { base, menu, settings } = this

        // set theme
        menu.classList.add('slinky-menu')
        menu.classList.add(settings.theme)

        // set transition speed
        this._transition(settings.speed)

        // add arrows to links with children
        let arrows = menu.querySelectorAll('a + ul');
        for (let index = 0; index < arrows.length; index++) {
            let element = arrows[index];
            element.previousElementSibling.classList.add('next');
        }

        // wrap link text with <span>
        // mostly for styling
        let wrapInner = menu.querySelectorAll('li > a');
        for (let index = 0; index < wrapInner.length; index++) {
            let element = wrapInner[index];
            element.innerHTML = '<span>' + element.innerHTML + '</span>';
        }

        // create header item
        let header = document.createElement("li");
        header.classList.add('header');

        // create back buttons
        let back = document.createElement("a");
        back.setAttribute("href", "#");
        back.innerHTML = 'Back';
        back.classList.add('back');

        header.appendChild(back);

        // prepend it to the list
        let uls = menu.querySelectorAll('li > ul');
        for (let index = 0; index < uls.length; index++) {
            let ul = uls[index];
            ul.innerHTML = header.outerHTML + ul.innerHTML;
            uls = menu.querySelectorAll('li > ul');
        }

        // do we need to add titles?
        if (settings.title) {
            // loop through each child list
            let elements = menu.querySelectorAll('li > ul');
            elements.forEach( (element, index) => {
                // console.log(index, element);
                const label = element.parentElement.querySelector('a').text;
                //console.log(label);
                if(label) {
                    let title = document.createElement('header');
                    title.classList.add('title');
                    title.innerHTML = label;
                    if(element.querySelector('.header')) {
                        element.querySelector('.header').appendChild(title);
                    } else {

                    }
                }
            });
        }

        // add click listeners
        this._addListeners()

        // jump to initial active
        this._jumpToInitial()
    }

    // click listeners
    _addListeners() {
        const { menu, settings } = this

        const aElements = menu.querySelectorAll('a');
        for (let index = 0; index < aElements.length; index++) {
            const element = aElements[index];
            element.addEventListener("click", (e) => {

                // prevent broken/half transitions
                if (this._clicked + settings.speed > Date.now()) {
                    return false
                }

                // cache click time to check on next click
                this._clicked = Date.now()

                // get the link
                const link = e.currentTarget;

                // prevent default if it's a hash
                // or a Slinky button
                const href = link?.getAttribute('href')?.indexOf('#') ?? 0;
                if (
                    href === 0 ||
                    link.classList.contains('next') ||
                    link.classList.contains('back')
                ) {
                    e.preventDefault()
                }

                // time to move
                if (link.classList.contains('next')) {
                    // one step forward

                    // remove the current active
                    if(menu.querySelector('.active')){
                        menu.querySelector('.active').classList.remove('active');
                    }

                    // set the new active
                    link.nextElementSibling.style.display = 'block';
                    link.nextElementSibling.classList.add('active');
                    // make the chess move
                    this._move(1)

                    // resize the menu if need be
                    if (settings.resize) {
                        this._resize(link.nextElementSibling)
                    }

                } else if (link.classList.contains('back')) {
                    // and two steps back
                    // just one step back, actually

                    // make the move
                    this._move(-1, () => {
                        // remove the current active
                        if(menu.querySelector('.active')) {
                            menu.querySelector('.active').classList.remove('active')
                        }

                        let linkParent = link.parentNode.parentNode;
                        linkParent.style.display = 'none';
                        let linkParentsUntil = getParentsUntil(linkParent, '#menu', 'ul');
                        linkParentsUntil[1].classList.add('active');
                    })

                    // resize the menu if need be
                    if (settings.resize) {
                        let linkParent = link.parentNode.parentNode;
                        let linkParentsUntil = getParentsUntil(linkParent, '#menu', 'ul');
                        this._resize(
                            linkParentsUntil[1]
                        )
                    }
                }
            });
        }
    }

    // jump to initial active on init
    _jumpToInitial() {
        const { menu, settings } = this

        // get initial active
        const active = menu.querySelector('.active');

        if (active) {
            // remove initial active
            active.classList.remove('active')

            // jump without animation
            this.jump(active, false)
        }

        // set initial height on the menu
        // to fix the first transition resize bug
        setTimeout( () => {
            // var headerHeight = getAbsoluteHeight( document.querySelector('header') );
            // var windowHeight = window.innerHeight;
            // console.log(windowHeight - headerHeight);
            // menu.style.height = (windowHeight - headerHeight) + 'px';

            // // console.log('initial height');
            // // var footerHeight = getAbsoluteHeight( document.querySelector('.mobile-menu-footer') );
            // // console.log(footerHeight);
            // // //menu.style.height = footerHeight + getAbsoluteHeight(content);
            // // menu.style.height = getAbsoluteHeight(menu) + footerHeight;
        }, settings.speed);
    }

    // slide the menu
    _move(depth = 0, callback = () => {}) {
        // don't bother packing if we're not going anywhere
        if (depth === 0) {
            return
        }

        const { settings, base } = this

        // get current position from the left
        const left = Math.round(parseInt(base.style.left)) || 0

        // set the new position from the left
        base.style.left = left - depth * 100 + '%';

        // callback after the animation
        if (typeof callback === 'function') {
            setTimeout(callback, settings.speed)
        }
    }

    // resize the menu
    // to match content height
    _resize(content) {
        const { menu } = this;

        var headerHeight = getAbsoluteHeight( document.querySelector('header') );
        var windowHeight = window.innerHeight;
        menu.style.height = (windowHeight - headerHeight) + 'px';


        var rootUL = document.querySelector('.root-ul');

        rootUL.style.height = getAbsoluteHeight( content ) + 'px';

        // var headerHeight = getAbsoluteHeight( document.querySelector('header') );
        // var windowHeight = window.innerHeight;
        // console.log(windowHeight - headerHeight);
        // menu.style.height = windowHeight - headerHeight;
        // // var footerHeight = getAbsoluteHeight( document.querySelector('.mobile-menu-footer') );
        // // menu.style.height = footerHeight + getAbsoluteHeight(content) + 'px';
    }

    // set the transition speed
    _transition(speed = 300) {
        const { menu, base } = this
        menu.style.transitionDuration = speed + 'ms';
        base.style.transitionDuration = speed + 'ms';
    }

    // jump to an element
    jump(target, animate = true) {
        if (!target) {
            return
        }

        const { menu, settings } = this

        const to = jQuery(target)

        // get all current active
        const active = menu.find('.active')

        // how many moves must we jump?
        let count = 0

        // this many
        // until we reach the parent list
        if (active.length > 0) {
            count = active.parentsUntil(menu, 'ul').length
        }

        // remove current active
        // hide all lists
        menu
            .find('ul')
            .removeClass('active')
            .hide()

        // get parent list
        const menus = to.parentsUntil(menu, 'ul')

        // show parent list
        menus.show()

        //
        to.show().addClass('active')

        // set transition speed to 0 if no animation
        if (!animate) {
            this._transition(0)
        }

        // make the checkers move
        this._move(menus.length - count)

        // resize menu if need be
        if (settings.resize) {
            this._resize(to)
        }

        // set transition speed to default after transition
        if (!animate) {
            this._transition(settings.speed)
        }
    }

    // go big or go home
    // just go home
    home(animate = true) {
        const { base, menu, settings } = this

        // set transition speed to 0 if no animation
        if (!animate) {
            this._transition(0)
        }

        // get current active
        const active = menu.find('.active')

        // get all parent lists
        const parents = active.parentsUntil(menu, 'ul')

        // make the move
        this._move(-parents.length, () => {
            // remove the current active
            active.removeClass('active').hide()

            // hide all parents except base
            parents.not(base).hide()
        })

        // resize if need be
        if (settings.resize) {
            this._resize(base)
        }

        // set transition speed back to default
        if (animate === false) {
            this._transition(settings.speed)
        }
    }

    // crush, kill, destroy
    destroy() {
        const { base, menu } = this

        // remove all headers
        jQuery('.header', menu).remove()

        // remove Slinky links
        // and click listeners
        jQuery('a', menu)
            .removeClass('next')
            .off('click')

        // remove inline styles
        menu.css({
        height: '',
            'transition-duration': ''
        })

        base.css({
            left: '',
            'transition-duration': ''
        })

        // remove Slinky HTML
        jQuery('li > a > span', menu)
            .contents()
            .unwrap()

        // remove any current active
        menu.find('.active').removeClass('active')

        // remove any Slinky style classes
        const styles = menu.attr('class').split(' ')

        styles.forEach(style => {
            if (style.indexOf('slinky') === 0) {
                menu.removeClass(style)
            }
        })

        // reset fields
        const fields = ['settings', 'menu', 'base']

        fields.forEach(field => delete this[field])
    }
}
